import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { DialogContentText } from '@material-ui/core';

export type Content = {
    message: string,
    messageBoldPrimary?: string,
}

interface ModalProps {
    open: boolean,

    title?: string,

    okText?: string,
    okShow?: boolean,
    okCallback?: () => void,

    cancelText?: string,
    cancelShow?: boolean,
    cancelCallback?: () => void,

    dialogContent: Content[],
    windowWidth?: number
}



class DialogInfo extends React.Component<ModalProps & WithStyles<typeof styles> & WithTranslation> {


    render() {
        const { classes } = this.props;

        let w = this.props.windowWidth || 1000

        return (
            <Dialog
                maxWidth="xs"
                open={this.props.open}
                onClose={this.props.cancelCallback ? this.props.cancelCallback : () => {}}
                onBackdropClick={this.props.cancelCallback ? this.props.cancelCallback : () => {}}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b>{this.props.title? this.props.title : <Trans>Choose</Trans>}</b>
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>


                    {this.props.dialogContent.map((text, index) => (
                        <DialogContentText key={index} style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px", fontSize: w < 600 ? "0.9rem" : "1rem" }}>
                            {text.message}
                            {text.messageBoldPrimary ?
                                <b className={classes.primary}>{text.messageBoldPrimary}</b> : null}
                        </DialogContentText>
                    ))}



                </DialogContent>
                <DialogActions>
                    {this.props.cancelShow ?
                    <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                        onClick={this.props.cancelCallback ? this.props.cancelCallback : () => {}}
                    >
                        <b>{this.props.cancelText ? this.props.cancelText : <Trans>Back</Trans>}</b>
                    </Button> : null}
                    {this.props.okShow ?
                    <Button variant="contained" color="primary" size="small" style={{ textTransform: "none" }}
                        onClick={this.props.okCallback ? this.props.okCallback : () => {} }
                    >
                        <b>{this.props.okText ? this.props.okText : "OK"}</b>
                    </Button> : null}
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
});

export default withTranslation()(withStyles(styles)(DialogInfo));